import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const CAT_LABEL = { research: "Research", policy: "Policy", industry: "Industry" };

export default function ArticleCard({ article, size = "md" }) {
  const isLg = size === "lg";
  const isExternal = Boolean(article.external_url);

  const inner = (
    <article className="h-full eai-card p-6 lg:p-8 flex flex-col justify-between">
      <div>
        <div className="flex items-center justify-between gap-4 mb-6">
          <span className="overline inline-flex items-center gap-2">
            {CAT_LABEL[article.category] || article.category}
          </span>
          <ArrowUpRight size={18} className="text-[var(--eai-ink-2)] group-hover:text-[var(--eai-accent)] transition-colors" />
        </div>
        <h3
          className={`font-display font-semibold leading-[1.1] tracking-tight ${
            isLg ? "text-2xl sm:text-3xl lg:text-4xl" : "text-xl lg:text-2xl"
          }`}
        >
          {article.title}
        </h3>
        {article.summary && (
          <p className={`mt-4 text-[var(--eai-ink-2)] ${isLg ? "text-base lg:text-lg" : "text-sm"} leading-relaxed`}>
            {article.summary}
          </p>
        )}
      </div>
      <footer className="mt-8 pt-6 border-t border-[var(--eai-border)] flex items-center justify-between text-xs font-mono-eai uppercase tracking-[0.16em] text-[var(--eai-ink-2)]">
        <span>{article.author}</span>
        <span>{article.read_minutes} min read</span>
      </footer>
    </article>
  );

  if (isExternal) {
    return (
      <a
        href={article.external_url}
        target="_blank"
        rel="noopener noreferrer"
        className="group block h-full"
        data-testid={`article-card-${article.slug}`}
      >
        {inner}
      </a>
    );
  }

  return (
    <Link
      to={`/intelligence/${article.slug}`}
      className="group block h-full"
      data-testid={`article-card-${article.slug}`}
    >
      {inner}
    </Link>
  );
}
